/**
 * Folha Fiscal design tokens, mirroring tailwind.config.ts. Use the Tailwind
 * utility classes (`bg-paper`, `text-ink`, etc.) directly in JSX; this
 * module exists for the rare cases where colors must be referenced from
 * TypeScript (e.g. canvas drawing, dynamic style props, tests).
 */
export const colors = {
  paper: '#F5F1EA',
  paperDark: '#EDE7DC',
  ink: '#1A1815',
  rule: '#C9C2B5',
  muted: '#5A5650',
  carimbo: '#8B2A1F',
  ocre: '#B5781A',
  oliva: '#3D5A3D',
} as const

export type ColorToken = keyof typeof colors

export const spacing = {
  pagePaddingX: 'px-12',
  pagePaddingY: 'py-10',
  hairline: 'border-t border-rule',
  ruleHeavy: 'border-t border-ink',
} as const

export const motion = {
  fastTransition: 'transition-colors duration-150',
  hoverReveal: 'opacity-0 group-hover:opacity-100 transition-opacity',
} as const

export const typeScale = {
  displayHero: 'font-display italic text-[44px] leading-none tracking-tight',
  displayLarge: 'font-display italic text-[28px] tracking-tight',
  displayMedium: 'font-display italic text-2xl',
  uppercaseLabel: 'text-[10px] uppercase tracking-widest2 text-muted',
  bodySmall: 'text-[13px] text-muted tracking-wide',
  mono: 'font-mono',
} as const

/**
 * Shared input field class. Uses an explicit 1px ink border (color-only
 * classes such as `border-ink` paint nothing without a width keyword),
 * swaps the border to `carimbo` on focus-visible so the user always
 * sees where the editable region starts and ends — important for date
 * inputs whose native widget can otherwise look borderless.
 */
export const inputClass =
  'border border-ink bg-paper px-3 py-2 text-sm text-ink focus-visible:border-carimbo focus-visible:outline-none placeholder:text-muted'

export const inputClassMono = `${inputClass} font-mono`
